import { render, staticRenderFns } from "./TechnicalDocsIcon.vue?vue&type=template&id=31d63409&scoped=true"
import script from "./TechnicalDocsIcon.vue?vue&type=script&lang=js"
export * from "./TechnicalDocsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d63409",
  null
  
)

export default component.exports